import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DataroomErrorHandler from '@dataroom/error-handler';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';
import { useDataroomListingContext } from '../../../../contexts/DataroomListingContext';
import { AlertManager } from '@dealroadshow/uikit-alert';
import getMessage from '@framework/message/getMessage';
import { messageCodes } from '@framework/message/messages';
import formatNumber from '@framework/data-helpers/formatters/formatNumber';
import DataroomStageRepository from '../../../../infrastructure/DataroomStageRepository';

export default function useStages() {
  const container = getContainer();
  const { getCollection } = useDataroomListingContext();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [stageData, setStageData] = useState<Record<string, number>>({});

  async function moveStage(dataroom: IDataroomListItem, isLive = false) {
    setIsFetching(true);

    try {
      const dataroomStageRepository = container.get<DataroomStageRepository>(DataroomStageRepository);
      const { investorsCount } = await dataroomStageRepository.moveDataroomStage({
        dataroomId: dataroom.id,
      }) || {};
      await getCollection();

      AlertManager.success(getMessage(messageCodes[isLive ? 'DATAROOM_STAGE_MOVE_TO_LIVE_SUCCESS' : 'DATAROOM_STAGE_MOVE_SUCCESS'], {
        prefix: dataroom.displayName,
        ...(isLive && { investorsCount: formatNumber(investorsCount) }),
      }));
    } catch (error) {
      container.get(DataroomErrorHandler)
        .handleError(error);
    } finally {
      setIsFetching(false);
    }
  }

  async function getStageData(dataroomId: number) {
    setIsFetching(true);

    try {
      const dataroomStageRepository = container.get<DataroomStageRepository>(DataroomStageRepository);
      const data = await dataroomStageRepository.getStageData({
        dataroomId,
      });
      setStageData(data);
      return data;
    } catch (error) {
      container.get(DataroomErrorHandler)
        .handleError(error);
    } finally {
      setIsFetching(false);
    }
    return null;
  }

  return {
    moveStage,
    isFetching,
    getStageData,
    stageData,
  };
}
